import styled from 'styled-components'

export const SpendTrackerPresenterStyled = styled.div`
  padding: 1rem;
`
